// extracted by mini-css-extract-plugin
export default {"MainWorkContainer":"ProjectsArea_MainWorkContainer__xY1vJ","cardContainer":"ProjectsArea_cardContainer__BxCUh","MainHeading":"ProjectsArea_MainHeading__zX9cf"};